import { Component, OnInit, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { TimeSensitive } from '../../../models/suggestion-engine-models';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-time-sensitive',
  templateUrl: './time-sensitive.component.html',
  styleUrls: ['./time-sensitive.component.scss'],
  imports: [NgxLoadingModule, MatCardModule],
})
export class TimeSensitiveComponent implements OnInit {
  private ses = inject(SuggestionEngineService);
  private router = inject(Router);
  private ss = inject(SessionStorageService);

  options: {
    id: string;
    name: string;
    suggestion: string;
    score: string;
  }[] = [];
  state: string = 'loading';

  ngOnInit() {
    this.ses.getTimeSensitive().subscribe((x: TimeSensitive) => {
      if (x.data && x.data.length) {
        this.options = x.data.map(z => {
          return {
            id: z.id,
            name: z.FullName,
            suggestion: z.bridgename,
            score: z.score,
          };
        });
        this.setProfileList(this.options);
        this.state = 'loaded';
      } else {
        this.options = [];
        this.setProfileList(this.options);
        this.state = 'none';
      }
    });
  }

  goToProfile(ev, id) {
    this.router.navigate([`/se/client/${id}`]);
  }

  setProfileList(list) {
    const filteredList = list.map(el => {
      return el.id;
    });
    this.ss.set('seProfileList', filteredList);
  }
}
